"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authProviderReducer = exports.authReducerActions = void 0;
const reducer_utils_1 = require("./reducer.utils");
const reducers = {
    login: (state, payload) => {
        return {
            ...state,
            user: payload
        };
    },
    logout: (state) => {
        return {
            ...state,
            tokens: undefined,
            user: undefined,
            activeLau: undefined
        };
    },
    setAuthTokens: (state, payload) => {
        return {
            ...state, tokens: {
                ...state.tokens,
                ...payload
            }
        };
    },
    setAuthInfo: (state, payload) => {
        console.log("XxX setAuthInfo", payload);
        return { ...state, user: payload };
    },
    setActiveLau: (state, payload) => {
        return { ...state, activeLau: payload };
    },
    refreshAuth: (state) => {
        return { ...state, activity: { latestRefresh: new Date() } };
    },
};
exports.authReducerActions = (0, reducer_utils_1.createActions)(reducers);
exports.authProviderReducer = (0, reducer_utils_1.createReducer)(reducers);
